import { createSelector } from 'reselect'
import * as ConversationSelectors from 'app/modules/conversation/selectors'
import * as constants from './constants'
import * as actions from './actions'

export const root = state => state.get('endUser')

export const endUsersById = state => root(state).get('byId')
const fetchStatusById = state => root(state).get('statusById')

export const makeEndUserSelector = () => createSelector(
  [
    root,
    (state, props) => props.id
  ],
  (root, id) => root.getIn(['byId', id])
)

export const makeFetchEndUserStatusSelector = () => createSelector(
  [
    fetchStatusById,
    (_, props) => props.endUserId
  ],
  (fetchStatusById, endUserId) => {
    return fetchStatusById.get(endUserId)
  }
)

export const makeFetchEndUserFailedSelector = () => {
  const fetchEndUserStatusSelector = makeFetchEndUserStatusSelector()
  return createSelector(
    [fetchEndUserStatusSelector],
    (endUserStatus) =>(
      endUserStatus === constants.FETCH_END_USER_FAILED ||
      endUserStatus === constants.FETCH_END_USER_LIST_FAILED
    )
  )
}

export const makeFetchEndUserLoadingSelector = () => {
  const fetchEndUserStatusSelector = makeFetchEndUserStatusSelector()
  return createSelector(
    [fetchEndUserStatusSelector],
    (endUserStatus) => (
      endUserStatus === constants.FETCH_END_USER_PENDING ||
      endUserStatus === constants.FETCH_END_USER_LIST_PENDING
    )
  )
}

export const unsubscribed = createSelector(root, root => root.getIn(['unsubscribed', 'value']))
export const unsubscribedStatus = createSelector(root, root => root.getIn(['unsubscribed', 'status']))
export const unsubscribePending = state => unsubscribedStatus(state) === actions.unsubscribePending.toString()
export const unsubscribeError = state => unsubscribedStatus(state) === actions.unsubscribeFailed.toString()
export const unsubscribeErrorMessage = state => root(state).getIn(['unsubscribed', 'errorMessage'])
export const unsubscribedCount = createSelector(root, root => root.get('unsubscribedCount'))
export const unsubRequestDeleteStatus = createSelector(root, root => root.getIn(['unsubscribed', 'requestUnsubDeleteDataStatus']))

export const resubscribed = createSelector(root, root => root.getIn(['resubscribed', 'value']))
export const resubscribedStatus = createSelector(root, root => root.getIn(['resubscribed', 'status']))
export const resubscribePending = state => resubscribedStatus(state) === actions.resubscribePending.toString()
export const resubscribeError = state => resubscribedStatus(state) === actions.resubscribeFailed.toString()
export const resubscribeErrorMessage = state => root(state).getIn(['resubscribed', 'errorMessage'])

export const isFetched = (state, props) => root(state).hasIn(['byId', props.id])

export const makeEndUserForConversationIdSelector = () => {
  const conversationSelector = ConversationSelectors.makeConversationSelector()
  return createSelector(
    [
      root,
      conversationSelector
    ],
    (root, conversation) => conversation && root.getIn(['byId', conversation.endUserId])
  )
}

export const makeEndUserIdFromConversationSelector = () => {
  const conversationSelector = ConversationSelectors.makeConversationSelector()
  
  return createSelector([conversationSelector], (conversation) => conversation && conversation.endUserId) 
}

export const makeFetchEndUserForConversationIdFailedSelector = () => {
  const conversationSelector = ConversationSelectors.makeConversationSelector()
  const fetchEndUserFailedSelector = makeFetchEndUserFailedSelector()

  return createSelector(
    [
      (state, props) => {
        const conversation = conversationSelector(state, { conversationId: props.conversationId })
        return conversation && fetchEndUserFailedSelector(state, { endUserId: conversation.endUserId })
      }
    ],
    (fetchEndUserFailed) => fetchEndUserFailed
  )
}

const following = createSelector(root, root => root.get('following'))

export const followingId = id => createSelector(following, following => following.getIn(['data', id]))

export const fetchFollowingStatus = id =>
  createSelector(following, following => following.getIn(['fetchFollowingState', id]))

export const updateFollowingStatus = id =>
  createSelector(following, following => following.getIn(['updateFollowingState', id]))

export const makeEndUserForConversationId = (conversation = ConversationSelectors.makeConversation()) =>
  createSelector(root, conversation, (root, conversation) => {
    return conversation && root.getIn(['byId', conversation.endUserId])
  })

export const isCreateAttributePending = (state, attribute) =>
  state.getIn(['endUser', 'propDefs', 'newlyCreated', attribute]) === 'PENDING'

export const activeEndUserChannels = state => root(state).get('activeEndUserChannels')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/selectors.js